module.exports = __webpack_public_path__ + "static/media/debit-wallet-arrow.dced9620.svg";